import React, {ComponentPropsWithoutRef, FC} from 'react';

import {twx} from '@/utils/tailwindUtils';

interface IFooterProps extends ComponentPropsWithoutRef<'div'> {}

export const Footer: FC<IFooterProps> = ({children, className, ...props}) => {
    return (
        <div
            className={twx('flex w-full justify-between rounded-xl bg-accent-dark p-4 text-left', className)}
            {...props}
        >
            {children}
        </div>
    );
};
